import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import { memo, useMemo } from 'react';
export const VehicleState = memo(function VehicleState(props) {
    const { state } = props;
    const { opened_doors, engine_working, hood_opened, trunk_opened } = state;
    const state_text = useMemo(() => {
        if (hood_opened && trunk_opened) {
            return 'Багажник и капот открыты';
        }
        if (hood_opened) {
            return 'Капот открыт';
        }
        if (trunk_opened) {
            return 'Багажник открыт';
        }
        if (opened_doors) {
            return 'Двери открыты';
        }
        if (engine_working) {
            return 'Двигатель работает';
        }
        return null;
    }, [state]);
    return (state_text && (_jsx(Box, { bgcolor: "primary.main", display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center", borderRadius: 8, py: 1, px: 2, children: _jsx(Typography, { color: "common.white", children: state_text }) })));
});
